import { render } from "./TicketDetailNew.vue?vue&type=template&id=4d5b93b2&scoped=true"
import script from "./TicketDetailNew.vue?vue&type=script&lang=js"
export * from "./TicketDetailNew.vue?vue&type=script&lang=js"

import "./TicketDetailNew.vue?vue&type=style&index=0&id=4d5b93b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5b93b2"]])

export default __exports__